const ID_ARTICLE_CONTEST = 'js-article-contest'
const QUERY_ARTICLE_CONTEST_BUTTON = '.js-article-contest-button'

import { getVotedArticle, vote } from '~/js/helpers/contest-helper'

document.addEventListener('DOMContentLoaded', async () => {
  const elementArticleContest = document.getElementById(ID_ARTICLE_CONTEST)
  if (!elementArticleContest) return

  const { votedArticleId } = await getVotedArticle()

  const { articleId, contestStatus } = elementArticleContest.dataset
  const elementsArticleContestButton = elementArticleContest.querySelectorAll(
    QUERY_ARTICLE_CONTEST_BUTTON
  )
  Array.from(elementsArticleContestButton).forEach(
    (elementArticleContestButton) => {
      if (votedArticleId == articleId) {
        elementArticleContestButton.innerText = 'このコーディネートに投票済み'
        return
      } else if (votedArticleId) {
        elementArticleContestButton.innerText = '投票済み'
        return
      }

      if (contestStatus !== 'active') return
      elementArticleContestButton.disabled = false

      elementArticleContestButton.addEventListener('click', async () => {
        if (!confirm('このコーディネートに投票します。よろしいですか？')) return

        elementsArticleContestButton.forEach((button) => {
          button.disabled = true
        })
        try {
          await vote(articleId)
          elementsArticleContestButton.forEach((button) => {
            button.innerText = 'このコーディネートに投票済み'
          })
        } catch (error) {
          console.error(error)
          elementsArticleContestButton.forEach(
            (button) => (button.disabled = false)
          )
        }
      })
    }
  )
})
